export default __webpack_public_path__ + "static/media/img5.906f2f13.jpg";